import { render, staticRenderFns } from "./ThgVehicleCard.vue?vue&type=template&id=0e447471"
import script from "./ThgVehicleCard.vue?vue&type=script&lang=ts"
export * from "./ThgVehicleCard.vue?vue&type=script&lang=ts"
import style0 from "./ThgVehicleCard.vue?vue&type=style&index=0&id=0e447471&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports